define(["require", "exports", "tslib", "mobx", "../EntityBase", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FacilityAssetHistory = void 0;
    class FacilityAssetHistory extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "Change", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Status", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Type", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FacilityAssetHistory.ObservableFields);
        }
        onCreate() {
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
        }
        onRead(entity) {
            if (entity.Change) {
                this.Change = entity.Change;
            }
            if (entity.RefId) {
                this.RefId = entity.RefId;
            }
            if (!isNaN(entity.Status)) {
                this.Status = (0, EntityUtil_1.toInt)(entity.Status);
            }
            if (entity.StatusDate) {
                this.StatusDate = entity.StatusDate;
            }
            if (entity.Type) {
                this.Type = entity.Type;
            }
        }
        onReady() {
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.Change = b.Change;
            a.RefId = b.RefId;
            a.Status = typeof b.Status != "number" ? (0, EntityUtil_1.toInt)(b.Status) : b.Status;
            a.StatusDate = b.StatusDate;
            a.Type = b.Type;
            this.postMerge();
        }
        postMerge() {
        }
        serialise() {
            return JSON.stringify(this);
        }
        hasChanges() {
            return this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED;
        }
        validate() {
            return null;
        }
        toJson() {
            return {
                Change: this.Change,
                RefId: this.RefId,
                Status: this.Status,
                StatusDate: this.StatusDate,
                Type: this.Type,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.FacilityAssetHistory = FacilityAssetHistory;
    Object.defineProperty(FacilityAssetHistory, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["Change", "RefId", "Status", "StatusDate", "Type"]
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityAssetHistory.prototype, "Change", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityAssetHistory.prototype, "ChangeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityAssetHistory.prototype, "RefId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityAssetHistory.prototype, "RefIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityAssetHistory.prototype, "Status", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityAssetHistory.prototype, "StatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityAssetHistory.prototype, "StatusDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityAssetHistory.prototype, "StatusDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityAssetHistory.prototype, "Type", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FacilityAssetHistory.prototype, "TypeError", void 0);
});
